// @ts-nocheck
const INTERCOM_APP_ID = 'y0ku07tr';
// Third-party Intercom bootstrap (verbatim widget snippet).
function setIntercomSettings(profile: { full_name: string; email: string }) {
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    name: profile.full_name,
    email: profile.email,
    currentURL: window.location.href,
  };
}

/**
 * Inline loader for the Intercom widget (legacy vendor snippet).
 * Runs only in production; call from App after mount when not in DEV.
 */
function bootstrapIntercomSnippet() {
  /* oxfmt-ignore IIFE third-party Intercom snippet */
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
}

export { setIntercomSettings, bootstrapIntercomSnippet };
